import { useLayoutEffect, useState } from "react";

export default function useWindowSize() {
  const [online, setOnline] = useState(true);

  const onlineFn = () => {
    console.log("ONLINE")
    setOnline(true)
  };

  const offlineFn = () => {
    console.log("OFFLINE")
    setOnline(false)
  }
  useLayoutEffect(() => {

    window.addEventListener('online', onlineFn);
    window.addEventListener('offline', offlineFn);
    
    return () => {
      window.removeEventListener('online', onlineFn);
      window.removeEventListener('offline', offlineFn)
    }
  }, []);
  return online;
}